import { useContext } from "react";
import { useAuth } from "../contexts/AuthContext";
import { ProductUpdateNotificationsContext } from "../contexts/ProductUpdateNotificationsContext";

/** Authentication readiness only; portfolio authorization is enforced by the API. */
export function useProductUpdateNotificationsEnabled(): boolean {
  const { user, isLoading } = useAuth();
  const enabled = useContext(ProductUpdateNotificationsContext);
  return enabled ?? (!isLoading && !!user?.id);
}
